import React, { useState } from "react";
import "./Login.css";
import AppLayout from "../../../layout/AppLayout";
import { FaMobileAlt, FaEnvelope } from "react-icons/fa";
import { IoChevronBack } from "react-icons/io5";
import Phone_Number_Login from "./Phone_Number_Login/Phone_Number_Login";
import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Email_Login from "./Email_Login/Email_Login";
import Login_Header from "../../Common/Common_Component/Login_Header/Login_Header";
import Verification_Puzzle_modal from "../../Common/Common_Component/Common_Modal/Verification_Puzzle_modal/Verification_Puzzle_modal";

const Login = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("phone");
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <>
        <div className="login-page">
          {/* Header */}
          <Login_Header
            title="Log in"
            subTitle="Please Log in with your phone number or email if you forget your password, Please contact customer service"
          />

          {/* Body */}
          <div className="login-body">
            {/* Tabs */}
            <div className="login-tabs">
              <div
                className={`tab ${activeTab === "phone" ? "active" : ""}`}
                onClick={() => setActiveTab("phone")}
              >
                <div>
                  <FaMobileAlt />
                </div>
                Phone Number
              </div>

              <div
                className={`tab ${activeTab === "email" ? "active" : ""}`}
                onClick={() => setActiveTab("email")}
              >
                <div>
                  <FaEnvelope />
                </div>
                Email Login
              </div>
            </div>

            {/* Phone Field */}
            {activeTab === "phone" && <Phone_Number_Login />}

            {/* Email Field */}
            {activeTab === "email" && <Email_Login />}

            {/* Remember */}
            <div className="remember mb-3">
              <Form.Check
                type="checkbox"
                label="Remember Password"
                className="checkbox_input"
              />
            </div>

            {/* Buttons */}
            <Button
              className="btn-login mb-3"
              onClick={() => setModalShow(true)}
            >
              Log in
            </Button>
            <Button
              className="btn-register  mb-3"
              onClick={() => navigate("/sign-up")}
            >
              Register
            </Button>

            {/* Bottom Links */}
            <div className="bottom_links">
              <div
                className="link_text"
                onClick={() => navigate("/forgot-password")}
              >
                <img
                  src="/assets/images/icons/lock.png"
                  alt="icon"
                  className="contact_icons"
                />
                <p>Forget Password</p>
              </div>
              <div className="link_text"   onClick={() => navigate("/self-service-center")}>
                <img
                  src="/assets/images/icons/chat.png"
                  alt="icon"
                  className="contact_icons"
                />
                <p>Customer Service</p>
              </div>
            </div>
          </div>
        </div>
        <Verification_Puzzle_modal
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
    </>
  );
};

export default Login;
